namespace('compass.tiles');

compass.tiles.FolioTileWidget = compass.defineWidget(function FolioTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _dialogId = compass.generateId();

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	this.render = function(widgetElem) {
		widgetElem.append(d.div({ className : 'smallTile tile', tabindex: accessibilty.TAB_INDEX, 'aria-role' : 'button', role : 'button', 'aria-owns':_dialogId},
			d.div({ className : 'smallTileHeader' },
				d.h3({ className : 'headerCopy' }, 'Hotel Folio'),
				d.div({ className : 'endHeader' })
			),
			d.div({ className : 'smallTileCopy'}, 
				d.span('View full hotel reservation details including policies, confirmation and more.&nbsp;'),
				d.span({className : 'link', 'aria-hidden' : 'true'}, "Click here &raquo;")
			)
		));
		widgetElem.activate(function(){
			me.trigger('FolioTileWidget.viewFullFolio',{ id: _dialogId });
		});
	};

	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultFolioTileWidgetGUID',
	widgetName : 'FolioTileWidget'
});
